import React from 'react';
import { NavLink } from 'react-router-dom'; // Import NavLink from react-router-dom
import '../css/Resources.css';

function Resources() {
  return (
    <div className="resources-sidebar">
      <NavLink to="/software" className="resources-nav-link">
        Software
      </NavLink>
      <NavLink to="/hardware" className="resources-nav-link">
        Hardware
      </NavLink>
      <NavLink to="/working_method" className="resources-nav-link">
      Demonstrate
      </NavLink>
      <NavLink to="/system_design" className="resources-nav-link">
        System Design
      </NavLink>
      <NavLink to="https://drive.google.com/file/d/1owA1xyP455OS90fmT2F1tJfR4_DllZlh/view?usp=sharing" className="resources-nav-link">
        IEEE Draft
        
      </NavLink>

      <NavLink to="/contribution" className="resources-nav-link">
        Contrubution
      </NavLink>
    </div>
  );
}

export default Resources;
